import React from "react";
import { Box } from "@mui/material";

const TagCard = ({
  children = null,
  className = "",
  overflow = null,
  sx = {},
}) => {
  return (
    <Box
      className={className}
      sx={{
        overflow: overflow ? "auto" : "visible",
        p: { xs: 2, md: "15px" },
        backgroundColor: "#FFFFFF",
        borderRadius: "6px",
        position: "relative",
        "&h1, & h2": {
          color: "#4d4d4d",
        },
        ...sx,
      }}
      key="tagCard"
    >
      {children}
    </Box>
  );
};

export default TagCard;
